var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.block.hidden)?_c('div',{staticClass:"post-image px-4 px-lg-5 py-5"},[(_vm.block.image.data)?_c('image-component',{staticClass:"post-image-image",class:'post-image-image-' + _vm.block.id + _vm.block.is_logo && _vm.block.is_logo === true
        ? 'is-logo'
        : ' ',attrs:{"image":_vm.block.image.data,"imageSize":'large',"lazy":true}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }